import { render, staticRenderFns } from "./DeckCardBasic.vue?vue&type=template&id=6db9ba62"
import script from "./DeckCardBasic.vue?vue&type=script&lang=js"
export * from "./DeckCardBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports